import { MY_WORKOUT } from "../types/actions";

const initialState = {
	myWorkoutList: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case MY_WORKOUT.GET_MY_WORKOUT:
			return { ...state, myWorkoutList: action.payload };
		case MY_WORKOUT.DELETE_MY_WORKOUTS:
			return { ...state, myWorkoutList: action.payload };
		default:
			return state;
	}
};
